import { OrganicTeamMember } from 'themes/organic/components';
import { ContainedSection } from 'themes/organic/components/sections/ContainedSection';
import { StaggeredList } from 'themes/organic/components/StaggeredList';

import { useTeamPage } from 'hooks/page/team/useTeamPage';

import { TProfessional } from 'types/appointment';

export const OrganicTeam = () => {
  const { professionals, handleBook } = useTeamPage();

  return (
    <ContainedSection title="Team" id="team">
      <StaggeredList
        id="team-members"
        items={professionals}
        renderItem={(item) => (
          <OrganicTeamMember
            professional={item as TProfessional}
            onClick={handleBook}
          />
        )}
      />
    </ContainedSection>
  );
};
